export const LgSizes14IconFull = () => {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="4.15086" y="3.75587" width="24.1042" height="12.1032" stroke="black" strokeWidth="1.51169"/>
            <rect x="4.15086" y="15.8396" width="24.1042" height="12.1032" stroke="black" strokeWidth="1.51169"/>
        </svg>
    )
}
export const LgSizes14IconFull = () => {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="4.15086" y="3.75587" width="24.1042" height="12.1032" stroke="black" strokeWidth="1.51169"/>
            <rect x="4.15086" y="15.8396" width="24.1042" height="12.1032" stroke="black" strokeWidth="1.51169"/>
        </svg>
    )
}
